import {
    getAsync,
    postAsync,
    putAsync,
    deleteAsync
} from "../helpers/apiHelper";

const endpoint = process.env.VUE_APP_BACKEND + "/api/WorkForm";

// Get all Work Forms for a discipline
export async function getWorkFormForDisciplineAsync(disciplineId) {
  return await getAsync(`${endpoint}/getAllForDiscipline/${disciplineId}`);
}

// Create an Work Form for a Discipline
export async function createWorkFormForDisciplineAsync(disciplineId, model) {
  return await postAsync(`${endpoint}/${disciplineId}`, model);
}

// Update an Work Form
export async function updateWorkFormAsync(model) {
  return await putAsync(`${endpoint}/${model.id}`, model);
}

// Delete an Work Form
export async function deleteWorkFormAsync(Id) {
  return await deleteAsync(`${endpoint}/${Id}`);
}